export default __webpack_public_path__ + "static/1095-a6a5b45a52242a98d7515a31760b00e8.gif";